import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function FinanceAccountValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    description: Yup.string()
      .min(3, t("LABEL.min"))
      .max(50, t("LABEL.max"))
      .required(t("LABEL.required")),
    bankId: Yup.string().required(t("LABEL.required")),
    shared: Yup.string().required(t("LABEL.required")),
    typeId: Yup.string().required(t("LABEL.required")),
    comments: Yup.string().min(3, t("LABEL.min")).optional(),
    number: Yup.string().optional(),
    agency: Yup.string().optional(),
    owner: Yup.string().optional(),
    is_default: Yup.number().optional(),
  });

  return validation;
}
